import { render, staticRenderFns } from "./needHelp.vue?vue&type=template&id=4cc8bea9&"
import script from "./needHelp.vue?vue&type=script&lang=js&"
export * from "./needHelp.vue?vue&type=script&lang=js&"
import style0 from "./needHelp.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports